// extracted by mini-css-extract-plugin
export default {"networkError":"NetworkError_networkError__8O-gb"};